import ToasterComponent from "../../view/shared/toasterComponent";
export const UtilityServices = {
  setLoggedInUserDetails: (data: any): void => {
    let roleNames;
    let permissionNames;
    if (data["role_names"]) {
      roleNames = Object.keys(data["role_names"]).map((element: string) => {
        if (element) {
          return element.toLowerCase();
        }
      });
    }
    if (data["permissions"]) {
      permissionNames = Object.keys(data["permissions"]).map(
        (element: string) => {
          if (element) {
            return element.toLowerCase();
          }
        }
      );
    }
    data.roleNames = roleNames;
    data.permissionNames = permissionNames;
    localStorage.setItem("loggedInUserDetail", JSON.stringify(data));
  },

  getLoggedInUserDetails: (): any => {
    let data = localStorage.getItem("loggedInUserDetail");
    if (data) {
      return JSON.parse(data);
    }
  },
  hasLoggedInUserType: (type: any): any => {
    let rawData = localStorage.getItem("loggedInUserDetail");
    if (rawData) {
      let data = JSON.parse(rawData);
      return data["user_type"] === type;
    }
    return false;
  },
  updateLoggedInUserDetails: (data: any): any => {
    localStorage.setItem("loggedInUserDetail", JSON.stringify(data));
  },

  clearAllBrowserStorage: (): any => {
    localStorage.clear();
    sessionStorage.clear();
  },

  getLoggedInUser: (getKey: any): any => {
    let rawData = localStorage.getItem("loggedInUserDetail");
    if (rawData) {
      let data = JSON.parse(rawData);
      if (data && data[getKey]) {
        return data[getKey];
      } else {
        return null;
      }
    }
  },
  hasPermissionOnComment: (comment: any): any => {
    let userDetailRaw = localStorage.getItem("loggedInUserDetail");
    if (!userDetailRaw) return false;
    const userDetail = JSON.parse(userDetailRaw);
    if (!userDetail.roleNames) return false;
    if (
      userDetail.roleNames.includes("super-admin") ||
      userDetail.roleNames.includes("admin") ||
      userDetail.roleNames.includes("client-admin")
    )
      return true;
    return userDetail.id == comment.commentby.id;
  },
  hasPermissionOnFollowup: (followup: any): any => {
    let userDetailRaw = localStorage.getItem("loggedInUserDetail");
    if (!userDetailRaw) return false;
    const userDetail = JSON.parse(userDetailRaw);
    if (!userDetail.roleNames) return false;
    if (
      userDetail.roleNames.includes("super-admin") ||
      userDetail.roleNames.includes("admin") ||
      userDetail.roleNames.includes("client-admin")
    )
      return true;
    return userDetail.id == followup.created_by;
  },
  hasPermission: (getKey: any): any => {
    let userDetailRaw = localStorage.getItem("loggedInUserDetail");
    if (!userDetailRaw) return false;
    const userDetail = JSON.parse(userDetailRaw);
    if (!userDetail.roleNames) return false;
    if (
      userDetail.roleNames.includes("super-admin") ||
      userDetail.roleNames.includes("admin")
    )
      return true;
    return userDetail.permissionNames.includes(getKey.toLowerCase());
  },
  hasLinkPermission: (getKey: any): any => {
    let userDetailRaw = localStorage.getItem("loggedInUserDetail");

    if (!userDetailRaw) return false;
    const userDetail = JSON.parse(userDetailRaw);
    if (!userDetail.roleNames) return false;
    if (
      userDetail.roleNames.includes("super-admin") ||
      userDetail.roleNames.includes("admin")
    )
      return true;
    return userDetail.link_names.includes(getKey.toLowerCase());
  },

  showToaster: ({
    placement = "topEnd",
    duration = 5000,
    type = "success",
    message,
    showIcon = true,
    closable = true,
    removeToaster = false,
  }: {
    placement?: any;
    duration?: number;
    type?: any;
    message: string;
    showIcon?: boolean;
    closable?: boolean;
    removeToaster?: boolean;
  }): any => {
    return ToasterComponent({
      type: type,
      message: message,
      duration: duration,
      closable: closable,
      placement: placement,
      showIcon: showIcon,
      removeToaster: removeToaster,
    });
  },

  clearToaster: () => {
    return ToasterComponent({ type: "", message: "", removeToaster: true });
  },
};
